import React from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaXTwitter,
  FaYoutube,
} from "react-icons/fa6";

const Homepage = () => {
  return (
    <div className="w-full mb-8"> {/* Removed md:mb-10 to avoid CLS */}
      <div className="text-black p-4 bg-white">

        {/* Hero Section */}
        <section className="flex flex-col md:py-10 px-4 md:px-10 lg:px-20 min-h-[300px]">
          <h1 className="text-2xl lg:text-4xl font-bold mb-4 text-[#1B0727]">
            BMRDA Approved Plots | Best Real Estate Company in Bangalore
          </h1>
          <p className="text-lg lg:text-xl mb-6 text-black font-bold">
            Welcome to Urban Nest Properties
          </p>
          <p className="text-md text-black">
            At Urban Nest Properties, we offer premium BMRDA approved plots in
            Bangalore with a strong focus on Chikka Madure, Nelamangala, and
            other high-potential corridors. As one of the best real estate
            companies in Bangalore, we help you secure residential plots, gated
            community layouts, and organic farm villas that are legally
            approved, strategically located, and value-driven.
          </p>
          <p className="mt-6 text-md text-black">
            Whether you're planning to build your dream home or make a secure
            investment, Urban Nest ensures complete transparency, fast
            processing, and expert support every step of the way.
          </p>
        </section>

        {/* Feature Highlights */}
        <section className="grid grid-cols-1 md:grid-cols-3 gap-6 px-4 md:px-10 lg:px-20 mt-5 md:mt-0">
          {[
            {
              title: "BMRDA Approved Plots",
              desc: "Fully legal and government-approved plots ready for construction or investment.",
            },
            {
              title: "Gated Communities",
              desc: "Secure living environments with modern amenities and community infrastructure.",
            },
            {
              title: "Farm Villas",
              desc: "Nature-rich lifestyle spaces for organic living and weekend retreats.",
            },
          ].map((item, idx) => (
            <section
              key={idx}
              className="bg-white/10 backdrop-blur-lg p-6 rounded-2xl border border-amber-500 shadow-md hover:shadow-xl transition duration-300"
            >
              <h2 className="text-xl font-semibold text-[#1B0727] mb-2">
                {item.title}
              </h2>
              <p className="text-sm text-black">{item.desc}</p>
            </section>
          ))}
        </section>

      </div>
    </div>
  );
};

export default Homepage;
